import React from "react";
import "./OurServiceDashboard.css";
import BackgroundFrame from "../BackgroundFrame/BackgroundFrame";   
import image1 from "../assest/image.jpg";
import image2 from "../assest/img2.avif";
import image3 from "../assest/img3.png"; 
import image4 from "../assest/skill_connect.svg";
import image5 from "../assest/aqrms.svg";
import image6 from "../assest/hrms.svg";
import image7 from "../assest/social 360.jpg";
import image8 from "../assest/NHM.jpeg";
export default function OurServiceDashboard() {
  const services = [
    {
      title: "AI GRAM",
      subtitle: "(AI-Based Grievance Management)",
      text: "AI-GRAM is an Artificial Intelligence-enabled grievance redressal and analytics platform designed for district administration. It allows citizens to submit complaints through multiple channels and uses AI to classify, prioritize, and route grievances to the appropriate departments.",
      img: image1,
      link: "https://aigram.texoriai.com/"
    },
    {
      title: "AMS",
      subtitle: "(Asset Management System)",
      text: "AI-AMS is an AI-powered Asset Management System that helps organizations track, monitor, and manage their assets automatically with smart insights and real-time updates.",
      img: image2,
      link: "https://aiams.texoriai.com/"
    },

    
    {
      title: "AQRMS",
      subtitle: "(Assembly Question Response Management System)",
      text: "An AI-based platform designed to manage, track, and analyse Assembly Questions across sessions and years.",
      img: image5,
      link: "https://aqrms.texoriai.com/"
    },
    {
      title: "SKILL CONNECT",
      subtitle: "",
      text: "A digital platform that connects students, training agencies, and professionals for skill development and employment. It streamlines training, certification, and job opportunities in one unified system.",
      img: image4,
      link: "https://skillconnect.texoriai.com/"
    },
        {
      title: "WorkFlux - PMMS",
      subtitle: "(Project Monitoring & Management System)",
      text: "WorkFlux - PMMS (Project Monitoring & Management System) is a digital platform that helps organizations track, manage, and monitor projects in real time with accuracy and transparency.",
      img: image3,
      link: "https://www.workflux.co.in/"
    },
    {
      title: "HRMS",
      subtitle: "(Human Resource Management System)",
      text: "A centralized platform designed to automate and manage complete human resource operations within an organization. It streamlines employee records, payroll, attendance, and recruitment in one system.",
      img: image6,
      link: "https://hrms.texoriai.com/"
    },
    {
      title: "SOCIAL 360",
      subtitle: "",
      text: "A unified social media management platform that helps teams plan content, monitor engagement, and track digital performance from a single dashboard.",
      img: image7,
      link: "https://social360.co.in/login"
    },
    {
      title: "NHM",
      subtitle: "(National Health Mission)",
      text: "A service-focused digital platform built to streamline health program monitoring, data access, and operational coordination for mission-driven public health workflows.",
      img: image8,
      link: "https://nhm.texoriai.com/"
    }
  ];

  return (
    <BackgroundFrame>   
      <div className="ourServiceDashboardMain">
        <h1 className="ourServiceDashboardTitle">Our Service</h1>

        <div className="ourServiceDashboardCards">
          {services.map((service, index) => (
            <div className="ourServiceDashboardCard" key={index}>
              <img src={service.img} alt={service.title} className="ourServiceDashboardImg" />
              <h2 className="ourServiceDashboardCardTitle">{service.title}</h2>
              {service.subtitle && <p className="ourServiceDashboardCardSubTitle">{service.subtitle}</p>}
              <p className="ourServiceDashboardCardText">{service.text}</p>
              <a href={service.link} target="_blank" rel="noreferrer">
                <button className="ourServiceDashboardCardBtn">Click Here</button>
              </a>
            </div>
          ))}
        </div>
      </div>
    </BackgroundFrame>
  );
}
